/**
 * RHH — article AI widget → BFF /v1/chat (stateless; sends history each request).
 * Aligns width to main article column; markdown render via marked + DOMPurify.
 */
(function () {
  var root = document.getElementById('rhh-ai-article-widget');
  if (!root) return;

  var ctxEl = document.getElementById('rhh-ai-article-context');
  if (!ctxEl) return;

  var context;
  try {
    context = JSON.parse(ctxEl.textContent);
  } catch (e) {
    return;
  }

  var bffBase = (root.getAttribute('data-bff-url') || '').replace(/\/$/, '');
  if (!bffBase) return;

  fetch(bffBase + '/v1/warmup', { method: 'GET', mode: 'cors' }).catch(function () {
    fetch(bffBase + '/v1/healthz', { method: 'GET', mode: 'cors' }).catch(function () {});
  });

  var WIDGET_INTRO = (root.getAttribute('data-widget-intro') || '').trim();

  var COUPON_COPY = {
    emailLabel: (root.getAttribute('data-coupon-email-label') || 'Email for your thank-you coupon').trim(),
    emailPlaceholder: (root.getAttribute('data-coupon-email-placeholder') || 'you@example.com').trim(),
    submit: (root.getAttribute('data-coupon-submit') || 'Send my coupon').trim(),
    submitting: (root.getAttribute('data-coupon-submitting') || 'Sending…').trim(),
    success: (root.getAttribute('data-coupon-success') || 'Thanks! Check your inbox for your coupon code.').trim(),
    error: (root.getAttribute('data-coupon-error') || 'Could not send right now. Try again in a moment.').trim(),
  };

  var activeCouponCapture = null;
  var COUPON_EMAIL_SUBMITTED_EVENT = '__event:coupon_email_submitted__';

  var VET_LOCATOR = {
    url: (root.getAttribute('data-vet-locator-url') || '/blogs/veterinarians').trim(),
    title: (root.getAttribute('data-vet-locator-title') || 'Find an exotics vet near you').trim(),
    body: (root.getAttribute('data-vet-locator-body') || 'Search Rabbit Hole Hay’s vet locator for small-animal and exotics clinics in your area.').trim(),
    cta: (root.getAttribute('data-vet-locator-cta') || 'Open vet locator').trim(),
    image: (root.getAttribute('data-vet-locator-image') || '').trim(),
  };

  var ASSISTANT_STYLE =
    'Keep replies concise and scannable: short paragraphs or bullets when it fits. ' +
    'Default to about 250–400 words maximum (roughly 1,500–2,400 characters) unless the user clearly asks for exhaustive detail. ' +
    'Start with the most direct answer, then brief context if needed. ' +
    'If asked about products outside the current article context or things you are not trained on, say: ' +
    '"I am not trained to answer that question yet. Please browse all our products."';

  var transcript = document.getElementById('rhh-ai-transcript');
  var input = document.getElementById('rhh-ai-input');
  var sendBtn = document.getElementById('rhh-ai-send-btn');
  var summaryBtn = document.getElementById('rhh-ai-summary-btn');
  var shell = document.getElementById('rhh-ai-shell');
  var minimizeBtn = document.getElementById('rhh-ai-minimize-btn');
  var fabBtn = document.getElementById('rhh-ai-fab-btn');
  var dockBtn = document.getElementById('rhh-ai-dock-btn');
  var peekBtn = document.getElementById('rhh-ai-peek-btn');
  var tabBtn = document.getElementById('rhh-ai-tab-btn');
  var autoMinBtn = document.getElementById('rhh-ai-auto-min-btn');
  var newChatBtn = document.getElementById('rhh-ai-new-chat-btn');
  var mobileToggleBtn = document.getElementById('rhh-ai-mobile-toggle');
  var mobileBadge = mobileToggleBtn
    ? mobileToggleBtn.querySelector('.rhh-ai-mobile-badge')
    : null;

  function defaultLayoutMode() {
    return isMobileView() ? 'bottom' : 'docked';
  }

  /** @type {'bottom'|'docked'} */
  var layoutMode = defaultLayoutMode();
  /** @type {'full'|'fab'} */
  var chromeMode = 'full';
  /** @type {'bottom'|'docked'} */
  var lastLayoutMode = defaultLayoutMode();
  var autoMinActive = false;
  var autoMinPrevOpen = false;
  var unreadCount = 0;

  var SESSION_STORAGE_KEY = 'rhh_ai_session_id';
  var CHAT_ID_STORAGE_KEY = 'rhh_ai_chat_id';
  var HISTORY_STORAGE_KEY = 'rhh_ai_history_turns';
  var ARTICLE_STORAGE_KEY = 'rhh_ai_article_handle';
  var MAX_HISTORY_TURNS = 36;
  /** Track engagement for analytics only; layout no longer persists across pages. */
  var WIDGET_ENGAGED_KEY = 'rhh_ai_widget_engaged';

  var SUMMARY_PROMPT =
    'Summarize this article in 5–8 bullet points of practical takeaways for small-pet owners. ' +
    'Be specific and concise; avoid long introductions or repetition.';
  var SUMMARY_PROMPT_NEW_PAGE_PREFIX =
    'I just switched to a new page. Please summarize this page as well.';

  /** @type {{role:'user'|'model', content:string}[]} */
  var historyTurns = [];
  var mobileMql = typeof window !== 'undefined'
    ? window.matchMedia('(max-width: 1023px)')
    : null;

  function uuidV4() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getOrCreateSessionId() {
    try {
      var s = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (s && s.length >= 16) return s;
      s = uuidV4();
      sessionStorage.setItem(SESSION_STORAGE_KEY, s);
      return s;
    } catch (e) {
      return 'sess_' + String(Date.now());
    }
  }

  function resetSessionIds() {
    try {
      sessionStorage.setItem(SESSION_STORAGE_KEY, uuidV4());
      sessionStorage.setItem(CHAT_ID_STORAGE_KEY, uuidV4());
    } catch (e) {
      /* ignore */
    }
  }

  /** One conversation id per browser tab session (all blog articles share it). */
  function getOrCreateChatId() {
    try {
      var s = sessionStorage.getItem(CHAT_ID_STORAGE_KEY);
      if (s && s.length >= 16) return s;
      s = uuidV4();
      sessionStorage.setItem(CHAT_ID_STORAGE_KEY, s);
      return s;
    } catch (e) {
      return 'chat_' + String(Date.now());
    }
  }

  function compactProducts(products) {
    if (!products || !products.length) return [];
    var out = [];
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var handle = typeof p === 'string' ? p : p && p.handle;
      if (handle) out.push({ handle: String(handle) });
    }
    return out;
  }

  function historyForApi() {
    var h = historyTurns.slice();
    while (h.length && h[0].role === 'model') {
      h.shift();
    }
    return h.map(function (t) {
      return { role: t.role, content: t.content };
    });
  }

  function loadHistoryFromStorage() {
    try {
      var raw = sessionStorage.getItem(HISTORY_STORAGE_KEY);
      if (!raw) return;
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return;
      historyTurns = [];
      for (var i = 0; i < parsed.length; i++) {
        var t = parsed[i];
        if (
          t &&
          (t.role === 'user' || t.role === 'model') &&
          typeof t.content === 'string'
        ) {
          var turn = { role: t.role, content: t.content };
          if (t.role === 'model') {
            var products = compactProducts(t.products);
            if (products.length) turn.products = products;
            if (t.couponOffer) turn.couponOffer = true;
            if (t.ddsQuestion) turn.ddsQuestion = true;
            if (t.vetLocator) turn.vetLocator = true;
          }
          historyTurns.push(turn);
        }
      }
      if (historyTurns.length > MAX_HISTORY_TURNS) {
        historyTurns = historyTurns.slice(-MAX_HISTORY_TURNS);
      }
    } catch (e) {
      historyTurns = [];
    }
  }

  function clearArticleContextSent() {
    lastSentArticleHandle = '';
    setStoredArticleHandle('');
  }

  function hasUserConversation() {
    for (var i = 0; i < historyTurns.length; i++) {
      if (historyTurns[i].role === 'user') return true;
    }
    return false;
  }

  function shouldAttachArticleContext() {
    var currentHandle = String(context.handle || '');
    return !!(currentHandle && currentHandle !== lastSentArticleHandle);
  }

  function markArticleContextSent() {
    var currentHandle = String(context.handle || '');
    if (!currentHandle) return;
    lastSentArticleHandle = currentHandle;
    setStoredArticleHandle(currentHandle);
  }

  function apiMessageWithPageContext(message, attachContext) {
    if (!attachContext || !message) return message;
    var priorUser = false;
    for (var i = 0; i < historyTurns.length; i++) {
      if (historyTurns[i].role === 'user') {
        priorUser = true;
        break;
      }
    }
    if (!priorUser) return message;
    var title = context.title ? String(context.title) : 'this page';
    return (
      '[The customer is now reading "' +
      title +
      '". Use the article title and summary provided with this request.]\n\n' +
      message
    );
  }

  function resetConversation() {
    historyTurns = [];
    saveHistoryToStorage();
    if (transcript) {
      transcript.innerHTML = '';
    }
    setOpen(true);
    ensureIntroAssistantMessage();
    resetSessionIds();
    clearArticleContextSent();
    autoMinActive = false;
    root.classList.remove('rhh-ai-article-widget--auto-min');
  }

  function summaryPromptForCurrentPage() {
    var currentHandle = String(context.handle || '');
    var priorHandle = getStoredArticleHandle();
    if (currentHandle && priorHandle && currentHandle !== priorHandle) {
      var title = context.title ? String(context.title) : 'this page';
      return (
        SUMMARY_PROMPT_NEW_PAGE_PREFIX +
        ' The page title is "' +
        title +
        '". ' +
        SUMMARY_PROMPT
      );
    }
    return SUMMARY_PROMPT;
  }

  function getStoredArticleHandle() {
    try {
      return sessionStorage.getItem(ARTICLE_STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function setStoredArticleHandle(handle) {
    try {
      sessionStorage.setItem(ARTICLE_STORAGE_KEY, handle || '');
    } catch (e) {
      /* ignore */
    }
  }

  function ensureIntroAssistantMessage() {
    if (!transcript || !WIDGET_INTRO) return;
    if (historyTurns.length > 0) return;
    historyTurns.push({ role: 'model', content: WIDGET_INTRO });
    appendModelBubble(WIDGET_INTRO, true);
    saveHistoryToStorage();
  }

  function saveHistoryToStorage() {
    try {
      sessionStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(historyTurns));
    } catch (e) {
      /* ignore quota / private mode */
    }
  }

  function markWidgetEngaged() {
    try {
      sessionStorage.setItem(WIDGET_ENGAGED_KEY, '1');
    } catch (e) {
      /* ignore */
    }
  }

  function isMobileView() {
    return mobileMql ? mobileMql.matches : false;
  }

  function isAutoMinEligible() {
    return layoutMode === 'bottom' && chromeMode === 'full' && !isMobileView();
  }

  function setAutoMinimized(next) {
    if (next && !isAutoMinEligible()) return;
    if (autoMinActive === next) return;
    autoMinActive = next;
    root.classList.toggle('rhh-ai-article-widget--auto-min', next);
    if (next) {
      autoMinPrevOpen = root.classList.contains('rhh-ai-article-widget--open');
      setOpen(false);
      root.setAttribute('data-ui-mode', 'auto-min');
      root.setAttribute('aria-expanded', 'false');
    } else {
      if (autoMinPrevOpen) {
        setOpen(true);
      }
      root.setAttribute('data-ui-mode', 'expanded');
      root.setAttribute('aria-expanded', 'true');
    }
    scheduleLayout();
  }

  var lastSentArticleHandle = getStoredArticleHandle();

  function setUnread(next) {
    if (!mobileBadge) return;
    unreadCount = Math.max(0, next || 0);
    if (unreadCount > 0) {
      mobileBadge.textContent = unreadCount > 9 ? '9+' : String(unreadCount);
      mobileBadge.classList.add('is-visible');
    } else {
      mobileBadge.textContent = '';
      mobileBadge.classList.remove('is-visible');
    }
  }

  function incrementUnread() {
    setUnread(unreadCount + 1);
  }

  function clearUnread() {
    setUnread(0);
  }

  function isWidgetEngaged() {
    try {
      return sessionStorage.getItem(WIDGET_ENGAGED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function persistChromeIfEngaged() {
    /* no-op: do not persist layout across pages */
  }

  function rebuildTranscriptFromHistory() {
    if (!transcript) return;
    transcript.innerHTML = '';
    for (var i = 0; i < historyTurns.length; i++) {
      var turn = historyTurns[i];
      if (turn.role === 'user') {
        appendUserBubble(turn.content, true);
      } else {
        appendModelBubble(turn.content, true, {
          couponOffer: !!turn.couponOffer,
          ddsQuestion: !!turn.ddsQuestion,
          vetLocator: !!turn.vetLocator,
          products: turn.products || [],
          skipAnalytics: true,
        });
      }
    }
    scrollTranscriptToBottom();
  }

  var alignScheduled = false;

  root.removeAttribute('hidden');

  function clearColumnAnchorStyles() {
    root.style.left = '';
    root.style.width = '';
    root.style.maxWidth = '';
    root.style.transform = '';
  }

  function applyChromeState() {
    var isFab = chromeMode === 'fab';
    var isMobile = isMobileView();
    var isDocked = layoutMode === 'docked' && !isMobile;
    var isEdge = false;

    if (isMobile && layoutMode !== 'bottom') {
      layoutMode = 'bottom';
      isDocked = false;
    }

    if (autoMinActive && !isAutoMinEligible()) {
      setAutoMinimized(false);
    }

    root.classList.toggle('rhh-ai-article-widget--fab', isFab);
    root.classList.toggle('rhh-ai-article-widget--docked', isDocked && !isFab);
    root.classList.toggle('rhh-ai-article-widget--edge', isDocked && isEdge);

    if (isFab || isDocked || isEdge) {
      root.classList.remove('rhh-ai-article-widget--anchored');
      if (isFab || (isDocked && !isEdge)) {
        clearColumnAnchorStyles();
      }
    }

    if (peekBtn) {
      if (isFab && !isMobile) {
        peekBtn.removeAttribute('hidden');
      } else {
        peekBtn.setAttribute('hidden', '');
      }
    }
    if (tabBtn) {
      if (isDocked && isEdge && !isFab) {
        tabBtn.removeAttribute('hidden');
      } else {
        tabBtn.setAttribute('hidden', '');
      }
    }

    if (autoMinActive) {
      root.setAttribute('data-ui-mode', 'auto-min');
    } else if (chromeMode === 'full' && layoutMode === 'bottom') {
      root.setAttribute('data-ui-mode', 'expanded');
    } else if (isFab) {
      root.setAttribute('data-ui-mode', 'minimized');
    } else if (isDocked) {
      root.setAttribute('data-ui-mode', 'docked');
    } else {
      root.setAttribute('data-ui-mode', 'docked');
    }

    var panelVisible = !isFab && !(isDocked && isEdge) && !autoMinActive;
    root.setAttribute('aria-expanded', panelVisible ? 'true' : 'false');
    root.classList.toggle(
      'rhh-ai-article-widget--mobile-minimized',
      isMobile && isFab,
    );

    if (dockBtn) {
      if (isMobile) {
        dockBtn.setAttribute('hidden', '');
      } else {
        dockBtn.removeAttribute('hidden');
      }
      if (layoutMode === 'bottom') {
        dockBtn.setAttribute('aria-label', 'Dock to side');
      } else {
        dockBtn.setAttribute('aria-label', 'Return Franklin Biltmore to bottom');
      }
      dockBtn.disabled = isFab;
    }
    if (minimizeBtn) {
      minimizeBtn.disabled = isFab;
    }

    if (panelVisible) {
      clearUnread();
    }
    persistChromeIfEngaged();
    autoResizeTextarea();
    scheduleLayout();
    updateDockedBodyState(isDocked && !isEdge && chromeMode === 'full' && !isMobile);
  }

  function updateDockedBodyState(isDocked) {
    if (!document.body) return;
    document.body.classList.toggle('rhh-ai-docked-body', isDocked);
    if (!isDocked) {
      document.documentElement.style.removeProperty('--rhh-ai-drawer-width');
      return;
    }
    requestAnimationFrame(function () {
      var rect = root.getBoundingClientRect();
      var width = rect && rect.width ? rect.width : 400;
      document.documentElement.style.setProperty(
        '--rhh-ai-drawer-width',
        width + 'px',
      );
    });
  }

  function scheduleLayout() {
    if (alignScheduled) return;
    alignScheduled = true;
    requestAnimationFrame(function () {
      alignScheduled = false;
      alignToArticleColumn();
    });
  }

  /**
   * Match main article column (not viewport center) — Minimog + Eating Guide fallbacks.
   */
  function alignToArticleColumn() {
    if (
      root.classList.contains('rhh-ai-article-widget--fab') ||
      root.classList.contains('rhh-ai-article-widget--docked')
    ) {
      return;
    }

    var anchor =
      document.querySelector(
        '[data-section-type="article-template"] .m-article__inner',
      ) ||
      document.querySelector('.m-article__inner') ||
      document.querySelector('.eating-guide-article .article-content') ||
      document.querySelector('.eating-guide-article') ||
      document.querySelector('#article-content-container');

    if (!anchor || typeof anchor.getBoundingClientRect !== 'function') {
      root.classList.remove('rhh-ai-article-widget--anchored');
      clearColumnAnchorStyles();
      return;
    }

    var r = anchor.getBoundingClientRect();
    if (r.width < 120) return;

    root.classList.add('rhh-ai-article-widget--anchored');
    root.style.left = r.left + 'px';
    root.style.width = r.width + 'px';
    root.style.maxWidth = 'none';
    root.style.transform = 'none';
  }

  function setOpen(next) {
    root.classList.toggle('rhh-ai-article-widget--open', next);
  }

  function autoResizeTextarea() {
    if (!input) return;
    var lines = input.value.split(/\n/).length;
    var minRows = layoutMode === 'docked' && !isMobileView() ? 2 : 1;
    var next = Math.min(4, Math.max(minRows, lines));
    input.rows = next;
    scheduleLayout();
  }

  function scrollTranscriptToBottom() {
    if (!transcript) return;
    transcript.scrollTop = transcript.scrollHeight;
  }

  function scrollBubbleToTop(el) {
    if (!transcript || !el) return;
    var pad = 8;
    var apply = function () {
      var transcriptRect = transcript.getBoundingClientRect();
      var elRect = el.getBoundingClientRect();
      var delta = elRect.top - transcriptRect.top - pad;
      transcript.scrollTop = Math.max(0, transcript.scrollTop + delta);
    };
    apply();
    requestAnimationFrame(apply);
    setTimeout(apply, 0);
  }

  function scrollResponseIntoView(anchorEl) {
    scrollBubbleToTop(anchorEl);
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function renderMarkdown(text) {
    if (!text) return '';
    try {
      if (window.marked && typeof window.marked.parse === 'function') {
        var raw = window.marked.parse(text, { breaks: true });
        if (
          window.DOMPurify &&
          typeof window.DOMPurify.sanitize === 'function'
        ) {
          return window.DOMPurify.sanitize(raw, {
            USE_PROFILES: { html: true },
          });
        }
        return raw;
      }
    } catch (err) {
      /* fall through */
    }
    return '<p>' + escapeHtml(text) + '</p>';
  }

  function appendUserBubble(text, skipScroll) {
    var el = document.createElement('div');
    el.className =
      'rhh-ai-article-widget__bubble rhh-ai-article-widget__bubble--user';
    el.textContent = text;
    transcript.appendChild(el);
    if (!skipScroll) scrollTranscriptToBottom();
  }

  function removeCouponCapture() {
    if (activeCouponCapture && activeCouponCapture.parentNode) {
      activeCouponCapture.parentNode.removeChild(activeCouponCapture);
    }
    activeCouponCapture = null;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function submitCouponLead(email, statusEl, submitBtn) {
    if (!submitBtn || !statusEl) return;
    submitBtn.disabled = true;
    statusEl.textContent = COUPON_COPY.submitting;
    statusEl.className = 'rhh-ai-coupon-capture__status';

    fetch(bffBase + '/v1/coupon/lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        session_id: getOrCreateSessionId(),
        chat_id: getOrCreateChatId(),
        shopify_shop_domain: context.shopDomain || '',
        article_handle: String(context.handle || ''),
      }),
    })
      .then(function (res) {
        return res.text().then(function (text) {
          var body = {};
          if (text) {
            try {
              body = JSON.parse(text);
            } catch (e) {
              body = {};
            }
          }
          return { ok: res.ok, body: body };
        });
      })
      .then(function (r) {
        if (!r.ok) {
          statusEl.textContent = COUPON_COPY.error;
          statusEl.className =
            'rhh-ai-coupon-capture__status rhh-ai-coupon-capture__status--error';
          submitBtn.disabled = false;
          return;
        }
        statusEl.textContent = COUPON_COPY.success;
        statusEl.className =
          'rhh-ai-coupon-capture__status rhh-ai-coupon-capture__status--success';
        if (activeCouponCapture) {
          var input = activeCouponCapture.querySelector('.rhh-ai-coupon-capture__input');
          if (input) input.disabled = true;
        }
        submitBtn.disabled = true;
        send(COUPON_EMAIL_SUBMITTED_EVENT, {
          hideUserBubble: true,
          historyUserContent: '[Submitted email for thank-you coupon]',
        });
      })
      .catch(function () {
        statusEl.textContent = COUPON_COPY.error;
        statusEl.className =
          'rhh-ai-coupon-capture__status rhh-ai-coupon-capture__status--error';
        submitBtn.disabled = false;
      });
  }

  function appendCouponCapture(afterBubble) {
    removeCouponCapture();

    var wrap = document.createElement('div');
    wrap.className = 'rhh-ai-coupon-capture';
    wrap.setAttribute('role', 'form');
    wrap.setAttribute('aria-label', COUPON_COPY.emailLabel);

    var label = document.createElement('label');
    label.className = 'rhh-ai-coupon-capture__label';
    label.textContent = COUPON_COPY.emailLabel;

    var row = document.createElement('form');
    row.className = 'rhh-ai-coupon-capture__row';
    row.noValidate = true;

    var input = document.createElement('input');
    input.type = 'email';
    input.name = 'email';
    input.className = 'rhh-ai-coupon-capture__input';
    input.placeholder = COUPON_COPY.emailPlaceholder;
    input.autocomplete = 'email';
    input.inputMode = 'email';
    input.autocapitalize = 'off';
    input.autocorrect = 'off';
    input.spellcheck = false;
    input.required = true;
    input.setAttribute('enterkeyhint', 'go');
    label.setAttribute('for', 'rhh-ai-coupon-email');
    input.id = 'rhh-ai-coupon-email';

    var submitBtn = document.createElement('button');
    submitBtn.type = 'submit';
    submitBtn.className = 'rhh-ai-coupon-capture__submit';
    submitBtn.textContent = COUPON_COPY.submit;

    var statusEl = document.createElement('p');
    statusEl.className = 'rhh-ai-coupon-capture__status';
    statusEl.setAttribute('aria-live', 'polite');

    function trySubmit() {
      var email = input.value.trim();
      if (!isValidEmail(email)) {
        statusEl.textContent = COUPON_COPY.error;
        statusEl.className =
          'rhh-ai-coupon-capture__status rhh-ai-coupon-capture__status--error';
        input.focus();
        return;
      }
      submitCouponLead(email, statusEl, submitBtn);
    }

    submitBtn.addEventListener('click', trySubmit);
    row.addEventListener('submit', function (e) {
      e.preventDefault();
      trySubmit();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        trySubmit();
      }
    });

    row.appendChild(input);
    row.appendChild(submitBtn);
    wrap.appendChild(label);
    wrap.appendChild(row);
    wrap.appendChild(statusEl);

    if (afterBubble && afterBubble.parentNode) {
      afterBubble.parentNode.insertBefore(wrap, afterBubble.nextSibling);
    } else if (transcript) {
      transcript.appendChild(wrap);
    }
    activeCouponCapture = wrap;
    if (afterBubble) scrollResponseIntoView(afterBubble);
  }

  function appendVetLocatorCard(afterBubble) {
    var href = VET_LOCATOR.url;
    if (href.indexOf('http') !== 0) {
      href = (context.shopUrl || '').replace(/\/$/, '') + (href.charAt(0) === '/' ? href : '/' + href);
    }

    var card = document.createElement('a');
    card.className = 'rhh-ai-vet-locator-card';
    card.href = href;
    card.target = '_blank';
    card.rel = 'noopener noreferrer';

    if (VET_LOCATOR.image) {
      var img = document.createElement('img');
      img.className = 'rhh-ai-vet-locator-card__img';
      img.src = VET_LOCATOR.image;
      img.alt = '';
      img.loading = 'lazy';
      card.appendChild(img);
    } else {
      var icon = document.createElement('div');
      icon.className = 'rhh-ai-vet-locator-card__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML =
        '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M12 21s6-5.2 6-10a6 6 0 1 0-12 0c0 4.8 6 10 6 10Z" stroke="currentColor" stroke-width="1.8"/>' +
        '<circle cx="12" cy="11" r="2.2" fill="currentColor"/></svg>';
      card.appendChild(icon);
    }

    var body = document.createElement('div');
    body.className = 'rhh-ai-vet-locator-card__body';
    body.innerHTML =
      '<div class="rhh-ai-vet-locator-card__title">' +
      escapeHtml(VET_LOCATOR.title) +
      '</div>' +
      '<div class="rhh-ai-vet-locator-card__text">' +
      escapeHtml(VET_LOCATOR.body) +
      '</div>' +
      '<span class="rhh-ai-vet-locator-card__cta">' +
      escapeHtml(VET_LOCATOR.cta) +
      '</span>';

    card.appendChild(body);

    if (afterBubble && afterBubble.parentNode) {
      afterBubble.parentNode.insertBefore(card, afterBubble.nextSibling);
    } else if (transcript) {
      transcript.appendChild(card);
    }
    if (afterBubble) scrollResponseIntoView(afterBubble);
  }

  function executeScripts(container) {
    if (!container) return;
    container.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function shopRootUrl() {
    if (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.root) {
      return window.MinimogSettings.routes.root;
    }
    var base = (context.shopUrl || 'https://www.rabbitholehay.com').replace(/\/$/, '');
    return base + '/';
  }

  function productFallbackLink(handle) {
    return (
      '<a class="rhh-ai-pdc rhh-ai-pdc--fallback" href="' +
      shopRootUrl() +
      'products/' +
      encodeURIComponent(handle) +
      '">View product</a>'
    );
  }

  function pushFranklinProductEvent(eventName, detail) {
    var payload = Object.assign(
      {
        event: eventName,
        source: 'franklin_ai',
        page_path: window.location.pathname,
        article_handle: String(context.handle || ''),
        session_id: getOrCreateSessionId(),
        chat_id: getOrCreateChatId(),
        page_type: (detail && (detail.render || detail.action || 'click')) || 'franklin',
      },
      detail || {}
    );
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try {
      if (typeof window.__rhhFpPublish === 'function') {
        window.__rhhFpPublish(eventName, payload);
      } else if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(eventName, payload);
      }
    } catch (e) {}
  }

  function franklinProductContext(card, fallbackHandle) {
    var rootCard = card && card.closest ? card.closest('.rhh-ai-pdc, .rhh-ai-product-cards__slot') : null;
    var handle =
      (rootCard && rootCard.getAttribute('data-product-handle')) ||
      (card && card.getAttribute && card.getAttribute('data-product-handle')) ||
      fallbackHandle ||
      '';
    var titleEl = rootCard
      ? rootCard.querySelector('.m-product-card__name, .rhh-ai-pdc__title a, .rhh-ai-pdc__title')
      : null;
    return {
      product_id: (rootCard && rootCard.getAttribute('data-product-id')) || '',
      product_handle: handle,
      product_title: titleEl ? String(titleEl.textContent || '').trim() : '',
    };
  }

  function bindFranklinProductCardAnalytics(slot, handle) {
    if (!slot || slot.getAttribute('data-franklin-analytics') === '1') return;
    slot.setAttribute('data-franklin-analytics', '1');

    slot.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest(
          'a.rhh-ai-pdc__media-link, a.m-product-card__name, a.m-product-card__link, a.rhh-ai-pdc__more-sizes, a.rhh-ai-pdc--fallback'
        );
        if (!link || !slot.contains(link)) return;
        pushFranklinProductEvent(
          'franklin_product_card_click',
          Object.assign(franklinProductContext(slot, handle), {
            click_target: link.className || 'link',
          })
        );
      },
      true
    );

    // Subscribe opens a modal (no form submit yet). ATC uses form submit only to avoid double-count.
    slot.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest('button.rhh-subscribe-button');
        if (!btn || !slot.contains(btn)) return;
        pushFranklinProductEvent(
          'franklin_product_card_atc',
          Object.assign(franklinProductContext(slot, handle), {
            action: 'subscribe',
          })
        );
      },
      true
    );

    slot.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !slot.contains(form)) return;
        if (!(form.matches && form.matches('form[data-type="add-to-cart-form"]'))) return;
        pushFranklinProductEvent(
          'franklin_product_card_atc',
          Object.assign(franklinProductContext(slot, handle), {
            action: 'add_to_cart',
          })
        );
      },
      true
    );
  }

  function extractPdcNode(html) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('.rhh-ai-pdc');
  }

  function pdcHtmlIsUsable(html) {
    if (!html) return false;
    if (html.indexOf('Liquid error') !== -1) return false;
    return html.indexOf('rhh-ai-pdc') !== -1;
  }

  function fetchPdcHtml(handle) {
    var base = shopRootUrl();
    var sectionUrl =
      base + 'products/' + encodeURIComponent(handle) + '?sections=rhh-ai-product-pdc';
    var viewUrl = base + 'products/' + encodeURIComponent(handle) + '?view=rhh-ai-pdc';

    function fromView() {
      return fetch(viewUrl).then(function (res) {
        return res.ok ? res.text() : '';
      });
    }

    function fromSection() {
      return fetch(sectionUrl)
        .then(function (res) {
          if (!res.ok) return '';
          return res.json();
        })
        .then(function (data) {
          return (data && data['rhh-ai-product-pdc']) || '';
        });
    }

    return fromView()
      .then(function (html) {
        if (pdcHtmlIsUsable(html)) return html;
        return fromSection().then(function (sectionHtml) {
          return pdcHtmlIsUsable(sectionHtml) ? sectionHtml : html || sectionHtml || '';
        });
      })
      .catch(function () {
        return fromSection()
          .then(function (sectionHtml) {
            return pdcHtmlIsUsable(sectionHtml) ? sectionHtml : '';
          })
          .catch(function () {
            return '';
          });
      });
  }

  function bindPdcSubscription(pdcRoot) {
    if (!pdcRoot || pdcRoot.getAttribute('data-rhh-pdc-sub-bound') === '1') return;
    var policyModal = pdcRoot.querySelector('.rhh-subscription-modal');
    var subscribeButtons = pdcRoot.querySelectorAll('.rhh-subscribe-button');
    if (!policyModal || !subscribeButtons.length) return;
    pdcRoot.setAttribute('data-rhh-pdc-sub-bound', '1');

    var closeModalButton = policyModal.querySelector('.custom-modal-close');
    var confirmButton = policyModal.querySelector('[id^="modal-confirm-add-to-cart-"]');
    var frequencySelect = policyModal.querySelector('.rhh-frequency-select--desktop');
    var frequencyValue = policyModal.querySelector('[id^="modal-frequency-value-"]');
    var frequencyList = policyModal.querySelector('.rhh-frequency-list--mobile');
    var frequencyOptions = policyModal.querySelectorAll('.rhh-frequency-list__option');
    var showMoreButton = policyModal.querySelector('.rhh-frequency-show-more');
    var productForm = pdcRoot.querySelector('form[data-type="add-to-cart-form"]');
    var modalPlaceholder = document.createComment('rhh-ai-pdc-subscription');

    function mountModal() {
      if (policyModal.parentElement === document.body) return;
      if (policyModal.parentElement) {
        policyModal.parentElement.insertBefore(modalPlaceholder, policyModal);
      }
      document.body.appendChild(policyModal);
    }

    function syncMobileSelection(planId) {
      if (!frequencyValue || !planId) return;
      frequencyValue.value = planId;
      frequencyOptions.forEach(function (option) {
        var selected = option.getAttribute('data-plan-id') === planId;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      if (frequencySelect) frequencySelect.value = planId;
    }

    function openModal() {
      mountModal();
      if (frequencyList) frequencyList.classList.add('is-collapsed');
      if (showMoreButton) showMoreButton.hidden = false;
      document.documentElement.classList.add('rhh-subscription-modal-open');
      policyModal.style.display = 'flex';
      policyModal.setAttribute('aria-hidden', 'false');
    }

    function closeModal() {
      policyModal.style.display = 'none';
      policyModal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rhh-subscription-modal-open');
      subscribeButtons.forEach(function (btn) {
        delete btn.dataset.rhhSubscribeActive;
      });
    }

    frequencyOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        syncMobileSelection(option.getAttribute('data-plan-id'));
      });
    });
    if (frequencySelect) {
      frequencySelect.addEventListener('change', function () {
        syncMobileSelection(frequencySelect.value);
      });
    }
    if (showMoreButton && frequencyList) {
      showMoreButton.addEventListener('click', function () {
        frequencyList.classList.remove('is-collapsed');
        showMoreButton.hidden = true;
      });
    }

    subscribeButtons.forEach(function (subscribeButton) {
      subscribeButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        subscribeButton.dataset.rhhSubscribeActive = 'true';
        openModal();
      });
    });

    if (confirmButton) {
      confirmButton.addEventListener('click', function () {
        var addToCartButton = productForm && productForm.querySelector('[name="add"]');
        var sellingPlanId = frequencyValue && frequencyValue.value;
        if (!productForm || !addToCartButton || !sellingPlanId) return;

        productForm.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
          input.remove();
        });
        var sellingPlanInput = document.createElement('input');
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.name = 'selling_plan';
        sellingPlanInput.value = sellingPlanId;
        productForm.appendChild(sellingPlanInput);

        if (productForm.requestSubmit) {
          productForm.requestSubmit(addToCartButton);
        } else {
          addToCartButton.click();
        }
        closeModal();
      });
    }

    if (closeModalButton) closeModalButton.addEventListener('click', closeModal);
    policyModal.addEventListener('click', function (e) {
      if (e.target === policyModal) closeModal();
    });
  }

  function mountPdcSlot(slot, handle, html, skipAnalytics) {
    var pdc = extractPdcNode(html);
    if (!pdc) {
      slot.innerHTML = productFallbackLink(handle);
      bindFranklinProductCardAnalytics(slot, handle);
      if (!skipAnalytics) {
        pushFranklinProductEvent(
          'franklin_product_card_impression',
          Object.assign(franklinProductContext(slot, handle), {
            render: 'fallback_link',
          })
        );
      }
      return;
    }
    slot.innerHTML = '';
    slot.appendChild(pdc);
    if (handle && !pdc.getAttribute('data-product-handle')) {
      pdc.setAttribute('data-product-handle', handle);
    }
    executeScripts(slot);
    cleanupAiPdcPayment(slot);
    bindPdcSubscription(pdc);
    bindFranklinProductCardAnalytics(slot, handle);
    if (!skipAnalytics) {
      pushFranklinProductEvent(
        'franklin_product_card_impression',
        Object.assign(franklinProductContext(pdc, handle), {
          render: 'pdc',
        })
      );
    }
  }

  function appendProductCards(products, afterBubble, skipAnalytics) {
    if (!products || !products.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'rhh-ai-product-cards';

    var pending = 0;
    products.forEach(function (product) {
      var handle = (product && product.handle) || '';
      if (!handle) return;

      pending += 1;
      var slot = document.createElement('div');
      slot.className = 'rhh-ai-product-cards__slot';
      slot.setAttribute('data-product-handle', handle);
      slot.innerHTML =
        '<div class="rhh-ai-pdc rhh-ai-pdc--loading" aria-busy="true">' +
        '<div class="rhh-ai-pdc__loading">Loading product…</div></div>';
      wrap.appendChild(slot);

      fetchPdcHtml(handle)
        .then(function (html) {
          mountPdcSlot(slot, handle, html, skipAnalytics);
        })
        .catch(function () {
          slot.innerHTML = productFallbackLink(handle);
          bindFranklinProductCardAnalytics(slot, handle);
          if (!skipAnalytics) {
            pushFranklinProductEvent(
              'franklin_product_card_impression',
              Object.assign(franklinProductContext(slot, handle), {
                render: 'fallback_link',
              })
            );
          }
        })
        .finally(function () {
          pending -= 1;
          if (pending <= 0 && afterBubble) {
            scrollResponseIntoView(afterBubble);
            setTimeout(function () {
              scrollResponseIntoView(afterBubble);
            }, 120);
          }
        });
    });

    if (afterBubble && afterBubble.parentNode) {
      afterBubble.parentNode.insertBefore(wrap, afterBubble.nextSibling);
    } else if (transcript) {
      transcript.appendChild(wrap);
    }
    if (afterBubble) {
      scrollResponseIntoView(afterBubble);
    }
  }

  function cleanupAiPdcPayment(root) {
    if (!root) return;
    root.querySelectorAll('.shopify-payment-button__skeleton').forEach(function (el) {
      el.remove();
    });
    root.querySelectorAll('.shopify-payment-button__button--hidden').forEach(function (el) {
      el.remove();
    });
  }

  function appendModelBubble(markdownOrPlain, skipScroll, opts) {
    opts = opts || {};
    var el = document.createElement('div');
    el.className =
      'rhh-ai-article-widget__bubble rhh-ai-article-widget__bubble--model';
    if (opts.ddsQuestion) {
      el.classList.add('rhh-ai-article-widget__bubble--dds');
    }
    var inner = document.createElement('div');
    inner.className = 'rhh-ai-md';
    inner.innerHTML = renderMarkdown(markdownOrPlain);
    el.appendChild(inner);
    transcript.appendChild(el);
    if (opts.couponOffer) {
      appendCouponCapture(el);
    }
    if (opts.vetLocator) {
      appendVetLocatorCard(el);
    }
    if (
      !opts.vetLocator &&
      !opts.couponOffer &&
      !opts.ddsQuestion &&
      opts.products &&
      opts.products.length
    ) {
      appendProductCards(opts.products, el, opts.skipAnalytics);
    }
    if (!skipScroll) scrollResponseIntoView(el);
    if (isMobileView() && chromeMode === 'fab') {
      incrementUnread();
    }
  }

  function appendErrorBubble(msg) {
    var el = document.createElement('div');
    el.className =
      'rhh-ai-article-widget__bubble rhh-ai-article-widget__bubble--model rhh-ai-article-widget__bubble--error';
    el.textContent = msg;
    transcript.appendChild(el);
    scrollBubbleToTop(el);
  }

  function showThinkingBubble() {
    var el = document.createElement('div');
    el.className =
      'rhh-ai-article-widget__bubble rhh-ai-article-widget__bubble--model rhh-ai-article-widget__bubble--thinking';
    el.setAttribute('aria-busy', 'true');
    el.innerHTML =
      '<span class="rhh-ai-thinking__label">Thinking</span>' +
      '<span class="rhh-ai-thinking__dots" aria-hidden="true"><span></span><span></span><span></span></span>';
    transcript.appendChild(el);
    scrollBubbleToTop(el);
    return el;
  }

  function removeEl(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function parseSseBlocks(buf, onEvent) {
    var parts = buf.split('\n\n');
    var rest = parts.pop();
    for (var i = 0; i < parts.length; i++) {
      var lines = parts[i].split('\n');
      var dataLines = [];
      for (var j = 0; j < lines.length; j++) {
        if (lines[j].indexOf('data:') === 0) {
          dataLines.push(lines[j].replace(/^data:\s?/, ''));
        }
      }
      if (!dataLines.length) continue;
      try {
        onEvent(JSON.parse(dataLines.join('\n')));
      } catch (e) {
        /* ignore malformed chunk */
      }
    }
    return rest;
  }

  function consumeSseResponse(res, onEvent) {
    if (!res.body || typeof res.body.getReader !== 'function') {
      return Promise.reject(new Error('no-stream'));
    }
    var reader = res.body.getReader();
    var decoder = new TextDecoder();
    var buf = '';
    function pump() {
      return reader.read().then(function (chunk) {
        if (chunk.value) {
          buf += decoder.decode(chunk.value, { stream: true });
          buf = parseSseBlocks(buf, onEvent);
        }
        if (chunk.done) {
          buf += decoder.decode();
          if (buf.trim()) parseSseBlocks(buf + '\n\n', onEvent);
          return;
        }
        return pump();
      });
    }
    return pump();
  }

  function isEventStream(res) {
    var ct = (res.headers && res.headers.get('content-type')) || '';
    return ct.indexOf('text/event-stream') !== -1;
  }

  function parseChatJsonResponse(res) {
    return res.text().then(function (text) {
      var body = {};
      if (text) {
        try {
          body = JSON.parse(text);
        } catch (e) {
          body = { detail: text.replace(/</g, ' ').slice(0, 280) };
        }
      }
      return { ok: res.ok, status: res.status, body: body };
    });
  }

  function fetchChatJson(payload) {
    return fetch(bffBase + '/v1/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(parseChatJsonResponse);
  }

  function finishChatTurn(reply, body, opts, attachContext, message) {
    appendModelBubble(reply, false, {
      couponOffer: !!(body && body.coupon_offer),
      ddsQuestion: !!(body && body.dds_question),
      vetLocator: !!(body && body.vet_locator),
      products: body && body.vet_locator ? [] : (body && body.products) || [],
    });
    var modelTurn = { role: 'model', content: reply };
    var servedProducts = compactProducts(
      body && body.vet_locator ? [] : (body && body.products) || []
    );
    if (servedProducts.length) modelTurn.products = servedProducts;
    if (body && body.coupon_offer) modelTurn.couponOffer = true;
    if (body && body.dds_question) modelTurn.ddsQuestion = true;
    if (body && body.vet_locator) modelTurn.vetLocator = true;
    historyTurns.push({
      role: 'user',
      content: opts.historyUserContent || message,
    });
    historyTurns.push(modelTurn);
    if (historyTurns.length > MAX_HISTORY_TURNS) {
      historyTurns = historyTurns.slice(-MAX_HISTORY_TURNS);
    }
    saveHistoryToStorage();
    if (attachContext) {
      markArticleContextSent();
    }
  }

  function attachStreamExtras(el, body) {
    if (!el || !body) return;
    if (body.dds_question) {
      el.classList.add('rhh-ai-article-widget__bubble--dds');
    }
    if (body.coupon_offer) {
      appendCouponCapture(el);
    }
    if (body.vet_locator) {
      appendVetLocatorCard(el);
    }
    if (
      !body.vet_locator &&
      !body.coupon_offer &&
      !body.dds_question &&
      body.products &&
      body.products.length
    ) {
      appendProductCards(body.products, el, false);
    }
  }

  function recordStreamHistory(reply, body, opts, attachContext, message) {
    var modelTurn = { role: 'model', content: reply };
    var servedProducts = compactProducts(
      body && body.vet_locator ? [] : (body && body.products) || []
    );
    if (servedProducts.length) modelTurn.products = servedProducts;
    if (body && body.coupon_offer) modelTurn.couponOffer = true;
    if (body && body.dds_question) modelTurn.ddsQuestion = true;
    if (body && body.vet_locator) modelTurn.vetLocator = true;
    historyTurns.push({
      role: 'user',
      content: opts.historyUserContent || message,
    });
    historyTurns.push(modelTurn);
    if (historyTurns.length > MAX_HISTORY_TURNS) {
      historyTurns = historyTurns.slice(-MAX_HISTORY_TURNS);
    }
    saveHistoryToStorage();
    if (attachContext) {
      markArticleContextSent();
    }
  }

  /**
   * @param {string} message
   * @param {{ hideUserBubble?: boolean }} [opts]
   */
  function send(message, opts) {
    message = (message || '').trim();
    if (!message || !sendBtn || !input) return;
    opts = opts || {};

    markWidgetEngaged();

    setOpen(true);

    if (!opts.hideUserBubble) {
      appendUserBubble(message);
    }

    sendBtn.disabled = true;

    var thinkingEl = showThinkingBubble();

    var currentHandle = String(context.handle || '');
    var isSystemEvent = message === COUPON_EMAIL_SUBMITTED_EVENT;
    var attachContext = !isSystemEvent && shouldAttachArticleContext();
    var payload = {
      message: apiMessageWithPageContext(message, attachContext),
      article_id: attachContext
        ? String(context.articleId || context.handle || '')
        : '',
      article_handle: currentHandle,
      article_title: attachContext ? context.title || '' : '',
      article_summary: attachContext ? context.summary || '' : '',
      history: historyForApi(),
      assistant_instructions: ASSISTANT_STYLE,
      session_id: getOrCreateSessionId(),
      chat_id: getOrCreateChatId(),
      shopify_shop_domain: context.shopDomain || '',
      shopify_customer_id:
        context.customerId != null && context.customerId !== ''
          ? String(context.customerId)
          : null,
    };
    if (context.handle) {
      payload.article_handle = String(context.handle);
    }
    if (context.shopDomain) {
      payload.shopify_shop_domain = String(context.shopDomain);
    }
    if (context.customerId != null && context.customerId !== '') {
      payload.shopify_customer_id = String(context.customerId);
    }

    var streamAccum = '';
    var streamInner = null;
    var streamFailed = false;
    var paintQueued = false;

    function paintStream() {
      paintQueued = false;
      if (!streamInner) return;
      streamInner.innerHTML = renderMarkdown(streamAccum);
    }

    function queuePaint() {
      if (paintQueued) return;
      paintQueued = true;
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(paintStream);
      } else {
        paintStream();
      }
    }

    function ensureStreamBubble() {
      if (streamInner || !thinkingEl) return;
      thinkingEl.classList.remove('rhh-ai-article-widget__bubble--thinking');
      thinkingEl.removeAttribute('aria-busy');
      thinkingEl.innerHTML = '';
      streamInner = document.createElement('div');
      streamInner.className = 'rhh-ai-md';
      thinkingEl.appendChild(streamInner);
    }

    function handleSseEvent(evt) {
      if (!evt || !evt.type) return;
      if (evt.type === 'delta' && evt.text) {
        ensureStreamBubble();
        streamAccum += evt.text;
        queuePaint();
      } else if (evt.type === 'replace' && typeof evt.text === 'string') {
        ensureStreamBubble();
        streamAccum = evt.text;
        queuePaint();
      } else if (evt.type === 'error') {
        streamFailed = true;
        removeEl(thinkingEl);
        thinkingEl = null;
        appendErrorBubble(
          typeof evt.detail === 'string' ? evt.detail : 'Request failed.',
        );
      } else if (evt.type === 'done') {
        var reply = evt.reply || streamAccum;
        if (!reply) {
          streamFailed = true;
          removeEl(thinkingEl);
          thinkingEl = null;
          appendErrorBubble('Empty response from Franklin Biltmore.');
          return;
        }
        ensureStreamBubble();
        streamAccum = reply;
        paintStream();
        attachStreamExtras(thinkingEl, evt);
        scrollResponseIntoView(thinkingEl);
        if (isMobileView() && chromeMode === 'fab') {
          incrementUnread();
        }
        recordStreamHistory(reply, evt, opts, attachContext, message);
        thinkingEl = null;
      }
    }

    function applyJsonResult(r) {
      removeEl(thinkingEl);
      thinkingEl = null;
      if (!r.ok) {
        var detail = r.body && (r.body.detail || r.body.message);
        appendErrorBubble(
          typeof detail === 'string'
            ? detail
            : 'Request failed (' + r.status + ').',
        );
        return;
      }
      var reply = r.body && r.body.reply;
      if (typeof reply !== 'string' || !reply.length) {
        appendErrorBubble('Empty response from Franklin Biltmore.');
        return;
      }
      finishChatTurn(reply, r.body, opts, attachContext, message);
    }

    fetch(bffBase + '/v1/chat/stream', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream',
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (res.ok && isEventStream(res)) {
          return consumeSseResponse(res, handleSseEvent).then(function () {
            if (streamFailed) return;
            if (!streamAccum && thinkingEl) {
              return fetchChatJson(payload).then(applyJsonResult);
            }
          });
        }
        if (res.status === 404 || res.status === 405 || !isEventStream(res)) {
          return fetchChatJson(payload).then(applyJsonResult);
        }
        return parseChatJsonResponse(res).then(applyJsonResult);
      })
      .catch(function () {
        if (streamInner) return;
        return fetchChatJson(payload)
          .then(applyJsonResult)
          .catch(function () {
            removeEl(thinkingEl);
            thinkingEl = null;
            appendErrorBubble('Network error. Check connection and BFF URL.');
          });
      })
      .finally(function () {
        if (thinkingEl && thinkingEl.classList.contains('rhh-ai-article-widget__bubble--thinking')) {
          removeEl(thinkingEl);
        }
        sendBtn.disabled = false;
        scheduleLayout();
      });

    input.value = '';
    autoResizeTextarea();
  }

  window.addEventListener('resize', scheduleLayout);
  window.addEventListener('scroll', scheduleLayout, { passive: true });

  if (shell && typeof ResizeObserver !== 'undefined') {
    var ro = new ResizeObserver(scheduleLayout);
    ro.observe(shell);
  }

  if (input) {
    input.addEventListener('input', function () {
      if (input.value.trim().length > 0) markWidgetEngaged();
      autoResizeTextarea();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        send(input.value);
      }
    });
  }

  if (sendBtn) {
    sendBtn.addEventListener('click', function () {
      send(input.value);
    });
  }

  if (summaryBtn) {
    summaryBtn.addEventListener('click', function () {
      send(summaryPromptForCurrentPage(), { hideUserBubble: true });
    });
  }

  if (newChatBtn) {
    newChatBtn.addEventListener('click', function () {
      resetConversation();
      applyChromeState();
    });
  }

  if (autoMinBtn) {
    autoMinBtn.addEventListener('click', function () {
      setAutoMinimized(false);
      setOpen(true);
      applyChromeState();
    });
  }

  if (minimizeBtn) {
    minimizeBtn.addEventListener('click', function () {
      setAutoMinimized(true);
      setOpen(false);
      applyChromeState();
    });
  }

  if (fabBtn) {
    fabBtn.addEventListener('click', function () {
      lastLayoutMode = layoutMode;
      chromeMode = 'fab';
      applyChromeState();
    });
  }

  if (dockBtn) {
    dockBtn.addEventListener('click', function () {
      if (chromeMode === 'fab') return;
      if (isMobileView()) return;
      if (layoutMode === 'bottom' && chromeMode === 'full') {
        layoutMode = 'docked';
        chromeMode = 'full';
        if (!hasUserConversation()) {
          setOpen(false);
        }
      } else if (layoutMode === 'docked' && chromeMode === 'full') {
        layoutMode = 'bottom';
        chromeMode = 'full';
      }
      applyChromeState();
    });
  }

  if (mobileToggleBtn) {
    mobileToggleBtn.addEventListener('click', function () {
      layoutMode = 'bottom';
      if (chromeMode === 'fab') {
        chromeMode = 'full';
        setOpen(true);
      } else {
        chromeMode = 'fab';
        setOpen(false);
      }
      applyChromeState();
    });
  }

  if (tabBtn) {
    tabBtn.addEventListener('click', function () {
      layoutMode = 'docked';
      chromeMode = 'full';
      applyChromeState();
    });
  }

  if (peekBtn) {
    peekBtn.addEventListener('click', function () {
      chromeMode = 'full';
      layoutMode = lastLayoutMode || defaultLayoutMode();
      setOpen(true);
      applyChromeState();
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!isAutoMinEligible()) return;
      if (chromeMode !== 'full') return;
      if (autoMinActive) return;
      if (root.contains(e.target)) return;
      setAutoMinimized(true);
      applyChromeState();
    },
    true,
  );

  loadHistoryFromStorage();
  if (historyTurns.length > 0) {
    markWidgetEngaged();
    rebuildTranscriptFromHistory();
    setOpen(true);
  } else {
    ensureIntroAssistantMessage();
  }

  applyChromeState();
  if (mobileMql && typeof mobileMql.addEventListener === 'function') {
    mobileMql.addEventListener('change', function () {
      applyChromeState();
    });
  } else if (mobileMql && typeof mobileMql.addListener === 'function') {
    mobileMql.addListener(function () {
      applyChromeState();
    });
  }
  autoResizeTextarea();
})();
